import { render, staticRenderFns } from "./PublishingContractsList.vue?vue&type=template&id=7ee9c74b"
import script from "./PublishingContractsList.vue?vue&type=script&lang=js"
export * from "./PublishingContractsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports